import React from 'react';
import { ListItem } from '@material-ui/core';
import ListItemText from '@material-ui/core/ListItemText';
import Popover from '@material-ui/core/Popover';
import useStyles from './styles';

export default ({
  anchorEl,
  open,
  handleClose,
  handleCancel,
  handleEdit,
  handleRescheduling,
  handleTransit,
  handlePrintPDF,
  showButtonCall,
  showButtonCallAgain,
  showButtonSend,
  cantCancell,
  cantCall,
  cantCallAgain,
  canEdit,
  canShowRescheduling,
  canRescheduling,
  cantTransit,
  handleMonitorOpen
}) => {
  const classes = useStyles();
  const { top = 0, left = 0 } = anchorEl?.getBoundingClientRect() ?? {};

  if (anchorEl === null) {
    return (<></>);
  }

  return (
    <>
      <Popover
        open={open}
        onClose={handleClose}
        anchorReference="anchorPosition"
        anchorEl={anchorEl}
        anchorPosition={{
          top: Math.ceil(top) + 35,
          left: Math.ceil(left) + 33
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        id={`popover-scheduling-component-id`}
        data-cy={`popover-scheduling-component-data-cy`}
      >
        {showButtonCall() && !cantCall() && (
          <ListItem button={true} disabled={cantCall()} onClick={handleMonitorOpen} id={`list-item-call-scheduling`} data-cy={`list-item-call-scheduling`}>
            <ListItemText className={classes.itemText} id={`list-item-text-call-scheduling`} data-cy={`list-item-text-call-scheduling`}>Chamar Agendamento</ListItemText>
          </ListItem>
        )}
        {showButtonCallAgain() && !cantCallAgain() && (
          <ListItem button={true} disabled={cantCallAgain()} onClick={handleMonitorOpen} id={`list-item-call-again-scheduling`} data-cy={`list-item-call-again-scheduling`}>
            <ListItemText className={classes.itemText} id={`list-item-text-call-again-scheduling`} data-cy={`list-item-text-call-again-scheduling`}>Chamar Novamente</ListItemText>
          </ListItem>
        )}
        {showButtonSend() && (
          <ListItem button={true} disabled={cantTransit()} onClick={handleTransit} id={`list-item-send-scheduling`} data-cy={`list-item-send-scheduling`}>
            <ListItemText className={classes.itemText} id={`list-item-text-send`} data-cy={`list-item-text-send`}>Enviar</ListItemText>
          </ListItem>
        )}
        {canEdit() && (
          <ListItem button={true} onClick={handleEdit} id={`list-item-edit-scheduling`} data-cy={`list-item-edit-scheduling`}>
            <ListItemText className={classes.itemText} id={`list-item-text-edit-scheduling`} data-cy={`list-item-text-edit-scheduling`}>Editar</ListItemText>
          </ListItem>
        )}
        <ListItem button={true} disabled={cantCancell()} onClick={handleCancel} id={`list-item-cancel-scheduling`} data-cy={`list-item-cancel-scheduling`}>
          <ListItemText className={classes.itemText} id={`list-item-text-cancel-scheduling`} data-cy={`list-item-text-cancel-scheduling`}>Cancelar</ListItemText>
        </ListItem>
          {canShowRescheduling() && (
            <ListItem button={true} disabled={!canRescheduling()} onClick={handleRescheduling} id={`list-item-rescheduling`} data-cy={`list-item-resscheduling`}>
              <ListItemText className={classes.itemText} id={`list-item-text-rescheduling`} data-cy={`list-item-text-rescheduling`}>Reagendar</ListItemText>
            </ListItem>
          )}
        <ListItem button={true} onClick={handlePrintPDF} id={`list-item-print-scheduling`} data-cy={`list-item-print-scheduling`}>
          <ListItemText className={classes.itemText} id={`list-item-text-print-scheduling`} data-cy={`list-item-text-print-scheduling`}>Imprimir PDF</ListItemText>
        </ListItem>
      </Popover>
    </>
  );
}
